/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_SourceInputs */



/**
* | output |
* | --- |
* | "Dialogue Source" |
*
* @param {Dialogue_SourceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_source = /** @type {((inputs?: Dialogue_SourceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_SourceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Source du dialogue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dialogquelle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fonte del dialogo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Источник диалога")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fuente del diálogo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("对话来源")
	if (locale === "ja") return /** @type {LocalizedString} */ ("対話の出典")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संवाद स्रोत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fonte do diálogo")
	return /** @type {LocalizedString} */ ("Dialogue Source")
});